export default "__VITE_ASSET__CZ0Uaygb__"